import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveNewCollective, requestLocationChange } from '../actions';
import Immutable from 'immutable';

import css from '../components/forms/forms.css';

// Form Components
import ParentAccountSearch from '../components/forms/ParentAccountSearch';
import Addresses from '../components/forms/Addresses';
import MediaPlatformDrawer from '../components/MediaPlatformDrawer';
import LoadingOverlay from '../components/LoadingOverlay';
import MultipleSelect from '../components/forms/MultipleSelect';

// Material UI Library
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import AutoComplete from 'material-ui/AutoComplete';
import Dialog from 'material-ui/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class NewCollective extends Component {

  constructor(props) {
    super(props);
    this.formAttributes = {
      name: '',
      parent: '',
      contactFirstName: '',
      contactLastName: '',
      contactPhone: '',
      contactEmail: '',
      contactMobile: '',
      contactFax: '',
      metacritic: false,
      gameRankings: false,
      collectiveId: null,
      addressesAttributes: Immutable.List(),
      type: '',
    };
    this.state = {
      openWarningDialog: false,
      openPlatformDrawer: false,
      saving: false,
      contactSalutation: '',
      collectiveMediaPlatformsAttributes: Immutable.List(),
      collectiveGameGenresAttributes: Immutable.List(),
      collectiveGamePlatformsAttributes: Immutable.List(),
    };

  }

  componentWillReceiveProps(newProps) {
    // if saving and returns a new collective
    if (
      !newProps.isFetching &&
      this.props.collectives.get('result') !== newProps.collectives.get('result')
    ) {
      this.props.dispatch(requestLocationChange('viewCollective', { id: newProps.collectives.get('result') }));
    }
  }

  componentWillUnmount() {
    // Cleanup
    this.formAttributes = null;
  }

  handleForm = (e) => {
    e.preventDefault();

    const newCollective =
      {
        collective: {
          name: this.formAttributes.name,
          collective_id: this.formAttributes.collectiveId,
          metacritic: this.formAttributes.metacritic,
          gameRankings: this.formAttributes.gamerRankings,
          type: this.formAttributes.type,
          contactAttributes: {
            firstName: this.formAttributes.contactFirstName,
            lastName: this.formAttributes.contactLastName,
            phone: this.formAttributes.contactPhone,
            email: this.formAttributes.contactEmail,
            mobile: this.formAttributes.contactMobile,
            fax: this.formAttributes.contactFax,
            salutation: this.state.contactSalutation,
          },
          addressesAttributes: this.formAttributes.addressesAttributes.toJS(),
          collectiveMediaPlatformsAttributes: this.state.collectiveMediaPlatformsAttributes.toJS(),
          collectiveGameGenresAttributes: this.state.collectiveGameGenresAttributes.toJS(),
          collectiveGamePlatformsAttributes: this.state.collectiveGamePlatformsAttributes.toJS(),
        },
      };

    this.props.dispatch(saveNewCollective(newCollective));
    this.setState({ saving: true });
  };

  handleCancelForm = (e) => {
    e.preventDefault();

    this.setState({ openWarningDialog: true });
  };

  handleFormUpdate = (property, value) => {
    this.formAttributes[property] = value;
  };

  handleTextChange = (property, e) => {
    this.handleFormUpdate(property, e.target.value);
  };

  handleChecked = (property, e, value) => {
    this.handleFormUpdate(property, value);
  };

  handleSelectMenu = (property, e, i, o) => {
    this.setState({
      [property]: o,
    });
  };

  handleCloseWarning = () => {
    this.setState({ openWarningDialog: false });
  };

  handleTogglePlatformDrawer = () => {
    this.setState({
      openPlatformDrawer: !this.state.openPlatformDrawer,
    });
  };

  handleChangeMediaType = (e, value) => {
    e.preventDefault();
    this.formAttributes.type = value;
  }

  handleAddPlatform = (platformAttributes) => {
    this.setState({
      collectiveMediaPlatformsAttributes: this.state.collectiveMediaPlatformsAttributes.push(Immutable.Map(platformAttributes)),
    });
    this.handleTogglePlatformDrawer();
  };

  handleExitForm = () => {
    this.props.dispatch(requestLocationChange('home'));
  };

  handleUpdateGamingPlatforms = (ids) => {
    this.setState({
      collectiveGamePlatformsAttributes: ids.map(id => ({ game_platform_id: id })),
    });
  };

  handleUpdateGamingGenres = (ids) => {
    this.setState({
      collectiveGameGenresAttributes: ids.map(id => ({ game_genre_id: id })),
    });
  };

  formStyles = () => ({
    checkboxContainer: {
      width: 'auto',
    },
    radio: {
      width: '50%',
    },
  });

  formComponents = () => [
    <section key="account-name">
      <TextField
        floatingLabelText="Account Name"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'name')}
      />
    </section>,
    <section key='parent-account'>
      <ParentAccountSearch
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'collectiveId')}
        updateForm={this.handleFormUpdate.bind(this, 'collectiveId')}
      />
    </section>,
    <h3 className={css.title} key='collective-type-title'>Collective Type</h3>,
    <RadioButtonGroup
      key="collective-type"
      name="type"
      defaultSelected="NewMediaCollective"
      labelPosition="left"
      onChange={this.handleChangeMediaType}
    >
      <RadioButton
        value="NewMediaCollective"
        label="Influencer"
        style={this.formStyles().radio}
        className={css.formField}
      />
      <RadioButton
        value="TraditionalMediaCollective"
        label="Media"
        style={this.formStyles().radio}
        className={css.formField}
      />
    </RadioButtonGroup>,
    <h3 className={css.title} key='primary-contacts-title'>Primary Contact</h3>,
    <section key="primary-contacts-1">
      <SelectField
        hintText="Salutation"
        value={this.state.contactSalutation}
        onChange={this.handleSelectMenu.bind(this, 'contactSalutation')}
        style={{ margin: '0 10px', paddingTop: '24px' }}
      >
        <MenuItem value={'Ms.'} primaryText="Ms." />
        <MenuItem value={'Mrs.'} primaryText="Mrs." />
        <MenuItem value={'Mr.'} primaryText="Mr." />
        <MenuItem value={'Dr.'} primaryText="Dr." />
        <MenuItem value={'Other'} primaryText="Other" />
      </SelectField>
      <TextField
        floatingLabelText="First Name"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'contactFirstName')}
      />
      <TextField
        floatingLabelText="Last Name"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'contactLastName')}
      />
    </section>,
    <section key="primary-contacts-2">
      <TextField
        floatingLabelText="Phone"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'contactPhone')}
      />
      <TextField
        floatingLabelText="Email"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'contactEmail')}
      />
      <TextField
        floatingLabelText="Mobile Phone"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'contactMobile')}
      />
      <TextField
        floatingLabelText="Fax"
        className={css.textField}
        fullWidth={true}
        onChange={this.handleTextChange.bind(this, 'contactFax')}
      />
    </section>,
    <Addresses
      key="addresses"
      fullWidth={true}
      updateForm={this.handleFormUpdate.bind(this, 'addressesAttributes')}
    />,
    <h3 className={css.title} key="media-platforms-title">Media Platforms</h3>,
    this.state.collectiveMediaPlatformsAttributes.map(platform =>
      <p>{this.props.mediaPlatforms.get(`${platform.get('mediaPlatformId')}`).get('name')}</p>
    ),
    <FlatButton
      key="open-platform-drawer"
      onTouchTap={this.handleTogglePlatformDrawer}
    >
      Add
    </FlatButton>,
    <h3 className={css.title} key="meta-data-title">Meta Data</h3>,
    <section key="meta-checkboxes">
      <Checkbox
        label="Metacritic Influencer"
        labelPosition="left"
        style={this.formStyles().checkboxContainer}
        className={css.formField}
        onCheck={this.handleChecked.bind(this, 'metacritic')}
      />
      <Checkbox
        label="GameRankings Influencer"
        labelPosition="left"
        style={this.formStyles().checkboxContainer}
        className={css.formField}
        onCheck={this.handleChecked.bind(this, 'gameRankings')}
      />
    </section>,
    <h3 className={css.title} key="gaming-platform-title">Gaming Platforms</h3>,
    <MultipleSelect
      key="gaming-platforms"
      items={this.props.gamePlatforms.get('entities')}
      result={this.props.gamePlatforms.get('result')}
      hintText="Select Platforms"
      onChange={this.handleUpdateGamingPlatforms}
    />,
    <h3 className={css.title} key="game-genre-title">Genres</h3>,
    <MultipleSelect
      key="gaming-genres"
      items={this.props.gameGenres.get('entities')}
      result={this.props.gameGenres.get('result')}
      hintText="Select Genres"
      onChange={this.handleUpdateGamingGenres}
    />,
    <MediaPlatformDrawer
      key="media-platform-drawer"
      open={this.state.openPlatformDrawer}
      addPlatform={this.handleAddPlatform}
      toggleDrawer={this.handleTogglePlatformDrawer}
    />,
    <Dialog
      key="cancel-form-dialog"
      title="Leave Page?"
      actions={[<FlatButton
          label="Cancel"
          secondary={true}
          onTouchTap={this.handleCloseWarning}
        />,
        <FlatButton
          label="Continue"
          primary={true}
          onTouchTap={this.handleExitForm}
        />,
      ]}
      modal={true}
      open={this.state.openWarningDialog}
    >
      You will lose all changes if you continue.
    </Dialog>,
  ];

  render() {
    return (
      <form onSubmit={this.handleForm} className={css.root} style={{ position: 'relative' }}>
        {this.formComponents()}
        <div className={css.actionFooter}>
          <RaisedButton
            secondary={true}
            type="button"
            onClick={this.handleCancelForm}
            style={{ marginRight: '15px' }}
            disabled={this.state.saving}
            label="Cancel"
          />
          <RaisedButton
            primary={true}
            type="submit"
            label="Save"
            disabled={this.state.saving}
          />
        </div>
        <LoadingOverlay loading={this.props.isFetching} />
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    mediaPlatforms: state.get('filterOptions').get('mediaPlatforms').get('entities'),
    gamePlatforms: state.get('filterOptions').get('gamePlatforms'),
    gameGenres: state.get('filterOptions').get('gameGenres'),
    collectives: state.get('collectives'),
    isFetching: state.get('collectives').get('isFetching'),
  };
}

export default connect(mapStateToProps)(NewCollective);



/** WEBPACK FOOTER **
 ** ./containers/NewCollective.js
 **/